import { Navigate, useLocation } from 'react-router-dom';

interface PublicRouteProps {
    isAuthenticated: boolean;
    children: JSX.Element;
}

const PublicRoute = ({ isAuthenticated, children }: PublicRouteProps) => {
    const location = useLocation();
    const state = location.state as { returnUrl?: string; returnState?: object } | undefined;

    if (isAuthenticated) {
        const to = state?.returnUrl || '/';
        return <Navigate to={to} state={state?.returnState} replace />;
    }
    return <>{children}</>;
};

export default PublicRoute;
